import React from 'react';
import { Pressable, View, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';
import Txt from './Txt';

interface SwitchProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
}

/** RN port of theme.css's .t-switch — 32×18 track with a sliding knob. */
export default function Switch({ checked, onChange, label, disabled, style }: SwitchProps) {
  const t = useTheme();
  return (
    <Pressable
      onPress={disabled ? undefined : () => onChange(!checked)}
      disabled={disabled}
      style={[{ flexDirection: 'row', alignItems: 'center', gap: 8, opacity: disabled ? 0.55 : 1 }, style]}
    >
      <View
        style={{
          width: 32,
          height: 18,
          borderRadius: t.radii.full,
          borderWidth: 1,
          borderColor: checked ? t.colors.accent : t.colors.lineStrong,
          backgroundColor: checked ? t.colors.accent : t.colors.paper3,
          justifyContent: 'center',
        }}
      >
        <View
          style={{
            width: 14,
            height: 14,
            borderRadius: 7,
            backgroundColor: t.colors.card,
            marginLeft: checked ? 16 : 1,
            ...t.shadows.sm,
          }}
        />
      </View>
      {label && <Txt size="sm" color="ink2">{label}</Txt>}
    </Pressable>
  );
}
